<template>
  <img :src="url" alt="" />
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss">
.modal.image-modal {
  max-height: 90vh;
  padding: 30px 0;

  .modal-card {
    padding: 10px;
    max-width: 100%;
    img {
      display: block;
      width: auto;
      max-height: 90vh;
      max-width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
